export class Styles {
}
Styles.defaultSizeGrid = [4, 4, 4, 4, 0];
Styles.labelColor = "#000000";
Styles.labelPadding = [2, 2, 2, 2];
Styles.inputLabelPadding = [1, 1, 1, 3];
Styles.buttonStateNum = 3;
Styles.buttonLabelColors = ["#32556b", "#32cc6b", "#ff0000"];
Styles.comboBoxItemColors = ["#5e95b6", "#ffffff", "#000000", "#8fa4b1", "#ffffff"];
Styles.scrollBarMinNum = 15;
Styles.scrollBarDelayTime = 500;
export var ScrollType;
(function (ScrollType) {
    ScrollType[ScrollType["None"] = 0] = "None";
    ScrollType[ScrollType["Horizontal"] = 1] = "Horizontal";
    ScrollType[ScrollType["Vertical"] = 2] = "Vertical";
    ScrollType[ScrollType["Both"] = 3] = "Both";
})(ScrollType || (ScrollType = {}));
